import JobHistory from '@/models/job-history'
import { groupBy, orderBy } from 'lodash'
import { computed } from 'vue'
import { useFormattedJobEvents } from './useFormattedJobEvents'
import { useGetJobHistory } from '@/api/composables/jobs/history'
import { useJobCommentsQuery } from '@/api/jobs'

export function useActivityLog(props: {
  jobId: string
  jobNumber: number
  jobHubId: string
  startTime?: moment.Moment | null
  endTime?: moment.Moment | null
}) {
  const { formattedJobEvents } = useFormattedJobEvents(props.jobId)

  const jobNumberRef = computed(() => props.jobNumber)
  const { data: history, isError: isHistoryError } = useGetJobHistory(jobNumberRef)
  const jobIdRef = computed(() => props.jobId)
  const { data: comments, isError: isCommentsError } = useJobCommentsQuery(jobIdRef)

  const jobCommentEntries = computed<JobHistory[]>(() => {
    if (!comments.value) return []

    return comments.value.map((comment) => {
      return new JobHistory({
        type: 'comment',
        modified: comment.createdOn,
        modified_by: comment.createdById,
        fields_changed: [
          {
            column_name: 'comment',
            original_value: comment.comment,
            new_value: null,
            is_important: true,
          },
        ],
      })
    })
  })

  const jobHistory = computed(() => {
    const allHistory = [
      ...formattedJobEvents.value,
      ...jobCommentEntries.value,
      ...(history.value ?? []),
    ]
    return groupBy(
      orderBy(allHistory, [(history) => history?.modified.unix()], ['desc']),
      (history) => history?.modified.format('MMM DD, YYYY'),
    )
  })

  return {
    jobHistory,
    isHistoryError: computed(() => isHistoryError.value || isCommentsError.value),
  }
}
